export default {
  "content": "<path d=\"M262.62 336L342 256l-79.38-80m68.35 80H170\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};